import { render, staticRenderFns } from "./ClassifyRow.vue?vue&type=template&id=45933656"
import script from "./ClassifyRow.vue?vue&type=script&lang=js"
export * from "./ClassifyRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports